if (!customElements.get('component-paginate')) {
  customElements.define('component-paginate', class ComponentPaginate extends HTMLElement {
    constructor() {
      super();
      this.section = null;
      this.sectionId = null;
      this.abortController = null;
    }

    connectedCallback() {
      // Find the parent section
      this.section = this.closest('section');
      
      if (!this.section) {
        console.warn('component-paginate: No parent <section> element found');
        return;
      }

      // Get section ID for targeting in fetched content
      this.sectionId = this.section.id;
      
      if (!this.sectionId) {
        console.warn('component-paginate: Parent section has no ID attribute');
        return;
      }

      // Listen for pagination clicks
      this.addEventListener('click', this.handleClick.bind(this));
    }

    disconnectedCallback() {
      // Cancel any pending fetch requests
      if (this.abortController) {
        this.abortController.abort();
      }
    }

    async handleClick(event) {
      // Handle event delegation for links with data-url
      const target = event.target.closest('[data-url]');
      if (!target) return;

      event.preventDefault();
      
      const url = target.dataset.url;
      if (!url) return;

      // Cancel previous request if still pending
      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();

      try {
        // Add loading state
        this.section.setAttribute('aria-busy', 'true');
        this.classList.add('loading');

        const response = await fetch(url, {
          signal: this.abortController.signal
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Find the matching section in fetched content by ID
        const selector = `#${this.sectionId}`;
        const newContent = doc.querySelector(selector);
        
        if (!newContent) {
          throw new Error(`No element with ID "${this.sectionId}" found in fetched content`);
        }

        // Update section content
        this.section.innerHTML = newContent.innerHTML;

        // Scroll to top of section smoothly
        this.section.scrollIntoView({ behavior: 'smooth', block: 'start' });

        // Update URL without page reload
        if (window.history && window.history.pushState) {
          window.history.pushState({ page: url }, '', url);
        }

        // Dispatch custom event for other components to react
        this.section.dispatchEvent(new CustomEvent('paginate:loaded', {
          bubbles: true,
          detail: { url, sectionId: this.sectionId }
        }));

      } catch (error) {
        if (error.name === 'AbortError') {
          console.log('Pagination fetch aborted');
          return;
        }
        
        console.error('Error loading paginated content:', error);
        
        // Fallback to regular navigation on error
        window.location.href = url;
      } finally {
        // Remove loading state
        this.section.removeAttribute('aria-busy');
        this.classList.remove('loading');
        this.abortController = null;
      }
    }
  });
}

